/* unplugin-vue-components disabled */import { render } from "./MockExamView.vue?vue&type=template&id=405300c7&scoped=true"
import script from "./MockExamView.vue?vue&type=script&lang=js"
export * from "./MockExamView.vue?vue&type=script&lang=js"

import "./MockExamView.vue?vue&type=style&index=0&id=405300c7&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-405300c7"]])

export default __exports__